<template>
  <div class="nodata">
    <img src="@/assets/img/bj_zanwushujv.png" alt="" srcset="">
    <span>
      <span class="bound">{{ $t('noData.prefix') }}{{ text }}{{ $t('noData.suffix') }}</span>
      <span v-if="isSearch">{{ $t('noData.tryAnotherKeyword') }}</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    isSearch: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.nodata{
  display: flex;
  font-size: 14px;
  color: #0D2340;
  padding-bottom: 70px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  img{
    width: 285px;
    // margin-bottom: 20px;
  }
  >span{
    width: 100%;
    display: flex;
    margin-top: -60px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    >span:last-child{
      font-weight: 500;
      font-size: 12px;
    }
  }
  .bound{
    font-weight: 600 !important;
  }
}
</style>
